import React from 'react';
import  {BsChatSquareText} from 'react-icons/bs';
import { FiPlus } from 'react-icons/fi';
import useStore from '../../store/useStore';

const ChatSidebar = ({ isOpen }) => {
  const { 
    activeChat, 
    createNewChat,
    agents,
    selectedAgent
  } = useStore();

  // Panel visual y botón de nuevo chat permanecen funcionales
  // No se muestra historial, solo un placeholder

  return (
    <div 
      className={`
        h-full border-l border-gray-200 dark:border-gray-700 
        bg-white dark:bg-gray-900 
        flex flex-col 
        transition-all duration-300 ease-in-out
        ${isOpen ? 'w-72 opacity-100' : 'w-0 opacity-0 overflow-hidden'}
      `}
    >
      {/* Contenedor interno para prevenir distorsión del contenido */}
      <div className="w-72 h-full flex flex-col">
        <div className="p-3 border-b border-gray-200 dark:border-gray-700">
          <h3 className="font-medium text-l px-2 mb-2 text-center text-gray-900 dark:text-gray-100">Historial de chats</h3>
          <button 
            onClick={() => createNewChat(selectedAgent)}
            className="w-full py-1 px-2 bg-blue-600 hover:bg-blue-700 text-white rounded flex items-center justify-center text-sm transition-colors"
            style={{ minHeight: '32px', maxWidth: '180px', margin: '0 auto' }}
          >
            <FiPlus className="mr-1" size={14} />
            <span>Nuevo chat</span>
          </button>
        </div>

        <div className="overflow-y-auto flex-1 p-2 scrollbar-hide">
          <div className="flex flex-col items-center justify-center h-40 text-center px-4">
            <BsChatSquareText className="mb-3 text-gray-400" size={24} />
            <p className="text-sm text-gray-500 dark:text-gray-400">Historial En Construcción</p>
            <p className="text-xs text-gray-400 dark:text-gray-500 mt-1">El historial ha sido desactivado temporalmente</p>
          </div>
        </div>
      </div> {/* Cierre del contenedor interno w-72 */}
    </div>
  );
};

export default ChatSidebar;
